import { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { dialogDuck } from '../../store';

const WithDialogHOC = (WrappedComponent) => {
    class WithDialog extends Component {
        static WrappedComponent = WrappedComponent;

        render() {
            const { props } = this;
            return <WrappedComponent {...props} />;
        }
    }

    const mapDispatchToProps = (dispatch) => {
        return {
            closeDialog: (dialogId) => {
                dispatch(dialogDuck.duckActionCreators.close(dialogId));
            },
            openDialog: (dialogId) => {
                dispatch(dialogDuck.duckActionCreators.open(dialogId));
            },
        };
    };

    WithDialog.propTypes = {
        openDialog: PropTypes.func.isRequired,
        closeDialog: PropTypes.func.isRequired,
    };

    return connect(null, mapDispatchToProps)(hoistNonReactStatics(WithDialog, WrappedComponent));
};

export default WithDialogHOC;
